export default __webpack_public_path__ + "static/media/group-7.dcf87257.png";